"use client";

import { useIsDark } from "@/context/ThemeContext";
import { twMerge } from "tailwind-merge";
import { Skeleton } from "antd";

export default function BlogPageSkeleton() {
  const isdark = useIsDark();

  return (
    <div
      className={twMerge(
        "relative flex flex-col items-center justify-center w-full 4xl:max-w-[2000px] 3xl:max-w-[1600px] 2xl:max-w-[1400px] xl:max-w-[1240px] lg:max-w-[1024px] md:max-w-[768px] sm:max-w-[640px] rounded-[20px] lg:rounded-[40px] mx-auto p-4 sm:p-6 md:p-8 lg:p-10 mt-16 2xl:mt-20 mb-10",
        isdark ? "bg-card" : "bg-[#F2E4FE]"
      )}
    >
      {/* Banner Image */}
      <div
        className="relative flex justify-center items-center rounded-lg overflow-hidden
        w-[300px] h-[188px]
        mobile:w-[380px] mobile:h-[238px]
        mobile2:w-[460px] mobile2:h-[288px]
        sm:w-[540px] sm:h-[338px]
        md:w-[640px] md:h-[402px]
        tablet:w-[700px] tablet:h-[438px]
        lg:w-[900px] lg:h-[564px]
        laptop:w-[1160px] laptop:h-[727px]
        2xl:w-[1280px] 2xl:h-[802px]
        3xl:w-[1420px] 3xl:h-[890px]
        4xl:w-[1560px] 4xl:h-[978px]"
      >
        <Skeleton.Image active className="!w-20 !h-20 !rounded-lg" />
      </div>

      {/* Author / Date / Categories */}
      <div className="flex flex-col sm:flex-row gap-[16px] sm:gap-[28px] md:gap-[79px] my-15 w-full justify-center">
        <Skeleton.Button active style={{ width: 160, height: 24 }} />
        <Skeleton.Button active style={{ width: 130, height: 24 }} />
        <Skeleton.Button active style={{ width: 190, height: 24 }} />
      </div>

      {/* Body content */}
      <div className="w-full mt-4">
        <Skeleton
          active
          title={false}
          paragraph={{ rows: 4, width: ["90%", "80%", "85%", "70%"] }}
        />
      </div>

      {/* Author details */}
      <div className="flex flex-col justify-start w-full mt-10 gap-2">
        <Skeleton.Input active style={{ width: 160, height: 24 }} />
        <Skeleton.Input active style={{ width: 100, height: 20 }} />
      </div>

      {/* Share icons */}
      <div className="flex justify-start w-full items-center gap-[18px] mt-15">
        <Skeleton.Input active style={{ width: 80, height: 24 }} />
        <div className="flex gap-[14px]">
          <Skeleton.Avatar active size={40} shape="circle" />
          <Skeleton.Avatar active size={40} shape="circle" />
          <Skeleton.Avatar active size={40} shape="circle" />
        </div>
      </div>
    </div>
  );
}
